


/*
 * Date: 2025
 * Description: Theme main context
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { useState , useCallback } from "react";


//Types
import { t_mode } from "../types/types";
import { i_app_color } from "../interfaces/utility.interface";
import { i_theme_context } from "../interfaces/context.interface";


//Utils
import { getLocalKey } from "../utils/utility";

const ThemeHook = (): i_theme_context => {
	const f_find_key = (): t_mode => {
		const key = getLocalKey("theme_mode");
		if (key !== null) return key;
		return "Light";
	};
	const [mode, setMode] = useState<t_mode>(f_find_key());
	const [primary_color, setPrimaryColor] = useState<string>("#B71F26");
	const [secondary_color, setSecondaryColor] = useState<string>("#555555");
	const [hover_color, setHoverColor] = useState<string>("#999999");
	const [selected_color, setSelectedColor] = useState<string>("#B71F26");

	const setCurrentTheme = useCallback((currentTheme: t_mode): void => {
		setMode(currentTheme);
	}, []);
	const setCurrentColor = useCallback((config: i_app_color): void => {
		setPrimaryColor(config.primary);
		setSecondaryColor(config.secondary);
		setHoverColor(config.hover);
		setSelectedColor(config.selected);
	}, []);
	return {
		mode: mode,
		primary: primary_color,
		secondary: secondary_color,
		selected: selected_color,
		hover: hover_color,
		setCurrentTheme: setCurrentTheme,
		setCurrentColor: setCurrentColor,
	};
};
export default ThemeHook